"use client";

import Carousel from "@/components/molecules/CustomCarousels/Carousel";
import Image from "next/image";
import styles from "./programhiglights.module.scss";
import usein from './hook';


export default function MBAHighlightsSection(data ) {
   const [textSectionRef, textSectionInView] = usein({ threshold: 0.1 });
   const programHighlight = data?.data

  return (
    <section className={styles.section}>
      <div className={styles.contentWrapper}>
        {/* Left side text */}
         <div 
          ref={textSectionRef} 
          className={`${styles.textSection} ${textSectionInView ? styles.inView : ''}`}
        >
          <h2 id="programhighlight-heading">{programHighlight?.Title}</h2>
          <div className={styles.logoContainer}>
          <img src={programHighlight?.Logo?.data?.attributes?.url} className={styles.logoimg} />
          </div>
          <p>{programHighlight?.Description}</p>
        </div>

        {/* Right side carousel */}
        <div className={styles.carouselSection}>
          <Carousel
          id = "programhighlight"
            className={"text-center"}
            config={{
              autoplay: { delay: 3000 },
              slidesPerView: 1,
              pagination: {
                status: true,
                className: "my-2"
              },
              breakpoints: {
                0: { slidesPerView: 1, spaceBetween: 10 },
            
                670: { slidesPerView: 2, spaceBetween: 10 },
                1280: { slidesPerView: 3, spaceBetween: 20 }
              }
            }}
          >
            {programHighlight?.Imagelist?.map((item, index) => (
              <div className={styles.card} key={index}>
                <div className={styles.cardImage}>
                <Image
                  src={item?.Image?.data?.attributes?.url}
                  alt={item.imageAlt ?? `Program Highlight Image ${index + 1}`}
                  width={500}
                  height={300}
                />
                </div>
                <div className={styles.cardBody}>
                  <h4>{item?.TitleCk}</h4>
                  <p>{item?.DescriptionCk}</p>
                </div>
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </section>
  );
}
